<template>
    <el-drawer
        :append-to-body="false"
        :modal-append-to-body="false"
        class="collect-map-drawer"
        title="物品详情"
        size="600px"
        direction="ltr"
        :visible.sync="visible"
        @closed="closed"
    >

        <el-carousel class="map-img-wrap" v-if="visible"
                     direction="vertical" :autoplay="false" ref="imgCarousel">
            <el-carousel-item class="map-img" label="标图" v-if="data.markerUrl">
                <img :src="data.markerUrl" alt="标图">
            </el-carousel-item>
            <el-carousel-item class="map-img" label="原图" v-if="data.baseUrl">
                <img :src="data.baseUrl" alt="原图">
            </el-carousel-item>
        </el-carousel>

        <div class="map-info-wrap">
            <div class="map-info">
                <h3 class="info-header">图像信息</h3>
                <ul class="info-body info-image">
                    <li>
                        <p class="title">物品名称：</p>
                        <p class="txt">{{data.imageName}}</p>
                    </li>
                    <li>
                        <p class="title">物品种类：</p>
                        <p class="txt">{{data.knowledgeName}}</p>
                    </li>
                    <li>
                        <p class="title">通道：</p>
                        <p class="txt">{{data.channel || ''}} {{data.channelTypeName}}</p>
                    </li>
                    <li>
                        <p class="title">漏检时间：</p>
                        <p class="txt">{{data.inspectTime}}</p>
                    </li>
                    <li>
                        <p class="title">漏检结果：</p>
                        <p class="txt">{{data.articleStatusName}}</p>
                    </li>
                    <li>
                        <p class="title">图像属性：</p>
                        <p class="txt">{{data.imagePropertyName}}</p>
                    </li>

                    <li>
                        <p class="title">图像描述：</p>
                        <p class="txt">{{data.imageDescription}}</p>
                    </li>
                </ul>
            </div>
            <div class="map-info">
                <h3 class="info-header">安检员信息</h3>
                <ul class="info-body info-watch">
                    <li>
                        <p class="title">安检员：</p>
                        <p class="txt">{{data.watchName}}</p>
                    </li>
                    <li>
                        <p class="title">机构：</p>
                        <p class="txt">{{data.orgName}}</p>
                    </li>
                    <li>
                        <p class="title">工号：</p>
                        <p class="txt">{{data.jobNo}}</p>
                    </li>
                    <li>
                        <p class="title">性别：</p>
                        <p class="txt">{{data.watchgenderName}}</p>
                    </li>
                    <li>
                        <p class="title">资质：</p>
                        <p class="txt">{{data.grade}}</p>
                    </li>
                </ul>
            </div>
            <div class="map-info">
                <h3 class="info-header">旅客信息</h3>
                <ul class="info-body info-passenger">
                    <li>
                        <p class="title">旅客姓名：</p>
                        <p class="txt">{{data.passengerName}}</p>
                    </li>
                    <li>
                        <p class="title">性别：</p>
                        <p class="txt">{{data.passengerGenderName}}</p>
                    </li>
                    <li>
                        <p class="title">年龄：</p>
                        <p class="txt">{{data.ageRangesName}}</p>
                    </li>
                    <li>
                        <p class="title">身份：</p>
                        <p class="txt">{{data.passengerTypeName}}</p>
                    </li>
                    <li>
                        <p class="title">航班号：</p>
                        <p class="txt">{{data.flight}}</p>
                    </li>
                    <li>
                        <p class="title">航班性质：</p>
                        <p class="txt">{{data.flightNatureName}}</p>
                    </li>
                    <li>
                        <p class="title">转机旅客：</p>
                        <p class="txt">{{data.isTransfer ? '是': data.isTransfer!==null? '否': ''}}</p>
                    </li>
                </ul>
            </div>
        </div>

    </el-drawer>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            showID: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                visible: false,
                data: {}
            }
        },
        computed: {},
        mounted() {

        },
        methods: {
            initDrawer() {
                this.$api.getOmitDetail(this.showID).then(res => {
                    this.data = res.package
                })
            },
            closed() {
                this.data = {}
            }
        },
        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.initDrawer()
                    // 关闭
                } else {
                    this.$emit('update:showID', 0)
                }
            },
            showID() {
                this.visible = !!this.showID
            }
        },
    }
</script>

<style lang="scss">
    @import '~@/style/const.scss';

    .collect-map-drawer {
        @include scrollbar(#aaa);

        .el-drawer__header {
            margin-bottom: 15px;
            font-size: 16px;
            color: #333;
            font-weight: 600;
        }
        .el-drawer__body {
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
        .el-carousel__indicators--labels {
            left: 90%;
        }

        .el-carousel__indicator {
            display: flex;
            flex-direction: row-reverse;

            .el-carousel__button {
                width: auto;
                height: auto;
                padding: 3px 10px;
            }
        }
        .map-img-wrap {
            height: 40%;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .map-info-wrap {
            flex: 1;
            overflow-y: auto;
            margin-top: 10px;
            padding: 10px 40px;
            background-color: #f9f9f9;
            box-shadow: 0px -2px 6px #eee;
            border-top: 1px solid #efefef;
        }
        .map-info {
            .info-header {
                font-size: 15px;
                padding: 0 10px;
                margin: 10px 0;
                color: #333;
                border-left: 4px solid #ccc;
            }
            .info-body {
                flex-wrap: wrap;
                li {
                    display: flex;
                    padding: 6px 0;
                }
            }
            .title {
                flex-shrink: 0;
                width: 100px;
                text-align: right;
                color: #666;
            }
            .txt {
                margin-left: 4px;
                color: #888;
            }
        }
    }
</style>
